import { clearTaskViewUrl, readTaskViewLocation, TASK_FILTER_QUERY_KEYS, type TaskViewLocation } from "./taskFilters";
import type { NotificationSection } from "./personalNotifications";

export const INBOX_SECTION_QUERY_KEY = "inbox_section";
const sections = new Set<NotificationSection>(["needs_me", "my_requests", "following"]);
/** Preserve execution intent in old copied links while making plain Inbox personal events. */
export function readWorkspaceNavigation(currentUrl: string): TaskViewLocation & { inboxSection: NotificationSection } {
  const url = new URL(currentUrl);
  if (!url.searchParams.has("task_view") && url.searchParams.has("taskView")) url.searchParams.set("task_view", url.searchParams.get("taskView")!);
  const old = readTaskViewLocation(url.toString());
  const taskIntent = old.serializedTaskView || (!old.explicitNavigation && [
    ...TASK_FILTER_QUERY_KEYS, "task_scope_user", "task_team", "task_search", "task_layout",
  ].some((key) => url.searchParams.has(key)));
  let requestedView = old.requestedView;
  let queryView = old.queryView;
  let serializedTaskView = old.serializedTaskView;
  if (requestedView === "inbox" && taskIntent) {
    requestedView = "my-issues"; queryView = "my-issues"; serializedTaskView = true;
    if (old.filters.statuses.length === 0) old.filters.statuses = ["backlog", "todo", "in_progress", "in_review"];
  } else if (requestedView === "notifications" || (requestedView === "awaiting-me" && !taskIntent)) requestedView = "inbox";
  const rawSection = url.searchParams.get(INBOX_SECTION_QUERY_KEY) as NotificationSection | null;
  return { ...old, requestedView, queryView, serializedTaskView, inboxSection: rawSection && sections.has(rawSection) ? rawSection : "needs_me" };
}
export function pendingDecisionsUrl(currentUrl: string): string {
  const url = new URL(currentUrl);
  url.searchParams.delete("task_nav"); url.searchParams.delete("taskView"); url.searchParams.delete(INBOX_SECTION_QUERY_KEY);
  for (const key of [...TASK_FILTER_QUERY_KEYS, "task_scope_user", "task_team", "task_search", "task_layout", "issue", "doc", "note", "project"]) url.searchParams.delete(key);
  url.searchParams.set("task_view", "awaiting-me"); url.hash = "awaiting-me";
  return `${url.pathname}${url.search}${url.hash}`;
}

/** Explicit markers survive login redirects that discard a hash. task_view=inbox stays legacy. */
export function personalNavigationUrl(currentUrl: string, view: "inbox" | "activity", section: NotificationSection = "needs_me"): string {
  const url = new URL(clearTaskViewUrl(currentUrl));
  url.searchParams.delete("taskView"); url.searchParams.delete(INBOX_SECTION_QUERY_KEY);
  url.searchParams.set("task_nav", view);
  if (view === "inbox") url.searchParams.set(INBOX_SECTION_QUERY_KEY, section);
  url.hash = view;
  return url.toString();
}
